(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Cart goal
  const progressBar = document.querySelector('#nf-cart-drawer-goal .progress-bar');
  if(progressBar) {
    setTimeout(() => { progressBar.style.width = progressBar.dataset.width; }, 250);
  }

  // Upsell recommendation (lazy-loaded)
  const productRecommendationsSection = document.querySelector('.product-recommendations');
  if(productRecommendationsSection) {
    const observer = new IntersectionObserver((entries, obs) => {
      if (!entries[0].isIntersecting) return;
      obs.unobserve(productRecommendationsSection);

      fetch(productRecommendationsSection.dataset.url)
        .then(res => res.text())
        .then(htmlText => {
          const html = document.createElement('div');
          html.innerHTML = htmlText;
          const recommendations = html.querySelector('.product-recommendations');
          if(recommendations?.innerHTML.trim()) productRecommendationsSection.innerHTML = recommendations.innerHTML;
          showHideBtn();
        }).catch(console.error);
    }, { rootMargin: '0px 0px 200px 0px' });
    observer.observe(productRecommendationsSection);
  }

  // Show/hide buttons
  function showHideBtn() {
    document.querySelectorAll('.drawer-upsell__action').forEach(container => {
      container.querySelectorAll('.upsell_variant_select').forEach(select => {
        if(select.options.length <= 2) {
          select.classList.add('hide-action__btn');
          const btn = container.querySelector('.cart_upsell_button--recommendation');
          btn.classList.remove('hide-action__btn');
          btn.addEventListener('click', () => {
            btn.remove();
            container.querySelector('.quick-add__submit').click();
            container.querySelector('.loading-overlay__spinner').classList.remove('hidden');
          });
        } else {
          container.querySelector('.cart_upsell_button--recommendation')?.remove();
          container.querySelector('.loading-overlay__spinner')?.remove();
        }

        select.addEventListener('change', (e) => {
          e.preventDefault();
          container.querySelector('.product-form__buttons .variant-id').setAttribute('value', select.value);
          select.remove();
          container.querySelector('.loading-overlay__spinner').classList.remove('hidden');
          container.querySelector('.quick-add__submit').click();
        });
      });
    });
  }
  showHideBtn();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
